<template>
  <div v-if="!isEmbedMode" class="contact-wrapper">
    <div class="contact py-3">
      <div class="contact-item text-start d-flex flex-grow">
        <span class="color--primary fw-600 text-start">
          Ficou alguma dúvida?
        </span>
      </div>
      <div class="contact-item">
        <Icon class="icon mx-1" name="phone" />
        <span>{{ arData.foneAR }}</span>
      </div>
      <div class="contact-item">
        <Icon class="icon mx-1" name="globe" />
        <a
          :href="`${
            arData.siteAR.includes('https://')
              ? arData.siteAR
              : `https://${arData.siteAR}`
          }`"
          class="text-decoration-underline"
          target="_blank"
        >
          {{ getSiteArFormatted }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { mapState } from 'pinia'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useEmbedConfig } from '@/composables'

  export default defineComponent({
    name: 'ContactContent',
    setup() {
      // TODO [Neilton] - Remove when apply i18n
      const { isEmbedMode } = useEmbedConfig()
      return { isEmbedMode }
    },
    computed: {
      ...mapState(useAR, ['arData', 'getSiteArFormatted']),
    },
    components: {
      Icon,
    },
  })
</script>

<style lang="stylus" scoped>
  .contact-wrapper
    display: flex
    justify-content: space-center
    align-items: center
    margin-top: 2rem
    width: 100%
  .contact
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    padding: 0 16px
    width: 100%
    max-height: 56px
    gap: 1rem;
    border: 1px solid #E6E7EC
    border-radius: 10px
  .contact-item
    display: flex
    flex-grow: 0

    &:first-child
      flex-grow: 1

    align-items: center
    gap: 0.5rem

  @media screen and (max-width: 575px)
    .contact-wrapper
      .contact
          display: flex
          flex-direction: column
          align-items: center
          flex-wrap: nowrap
</style>
